export default __webpack_public_path__ + "images/mathflat_logo.png";